var React = require('react');

function EmailInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.125 3.8875C0.377045 2.78311 0.996638 1.79703 1.8823 1.09077C2.76797 0.384509 3.86721 -7.62361e-05 5 1.13353e-08H35C36.1328 -7.62361e-05 37.232 0.384509 38.1177 1.09077C39.0034 1.79703 39.623 2.78311 39.875 3.8875L20 16.035L0.125 3.8875ZM0 6.7425V24.5025L14.5075 15.6075L0 6.7425ZM16.9025 17.075L0.4775 27.1425C0.883316 27.9982 1.52382 28.7211 2.32445 29.2269C3.12509 29.7328 4.05294 30.0009 5 30H35C35.9469 30.0002 36.8744 29.7315 37.6746 29.2252C38.4748 28.7189 39.1147 27.9958 39.52 27.14L23.095 17.0725L20 18.965L16.9025 17.0725V17.075ZM25.4925 15.61L40 24.5025V6.7425L25.4925 15.6075V15.61Z","fill":"white"}));
}

EmailInline.defaultProps = {"width":"40","height":"30","viewBox":"0 0 40 30","fill":"none"};

module.exports = EmailInline;

EmailInline.default = EmailInline;
